var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "f7-page",
    [
      _c(
        "b-container",
        {
          staticClass: "main-content icon-homepage-button-request-payment",
          attrs: { fluid: "" },
        },
        [
          _c(
            "b-row",
            { staticClass: "homepageTextBloc1" },
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade-title", appear: "" } },
                    [
                      _c(
                        "h1",
                        {
                          staticClass: "d-block text-center text-white",
                          staticStyle: { "font-size": "4rem !important" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Homepage.welcome_toolbox")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "slide-fade-title", appear: "" } },
            [
              _vm.data
                ? _c(
                    "b-row",
                    { staticClass: "homepageCards offset-2 col-8" },
                    [
                      _c(
                        "carousel",
                        {
                          staticClass: "col-12",
                          attrs: {
                            items: _vm.nbMaxItem,
                            center: "",
                            loop: "",
                            nav: false,
                            dots: true,
                            autoplay: _vm.data.length > _vm.nbMaxItem,
                          },
                        },
                        _vm._l(_vm.data, function (button) {
                          return _vm.hasRight(button.right)
                            ? _c(
                                "b-col",
                                {
                                  key: button.id,
                                  staticClass:
                                    "d-flex flex-row justify-content-center",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "homeCardBody text-center",
                                      class: button.class,
                                      on: {
                                        click: function ($event) {
                                          return _vm.redirect(button.link)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class: button.icon,
                                        staticStyle: { "font-size": "50px" },
                                      }),
                                      _vm._v(" "),
                                      _c("h4", [
                                        _vm._v(_vm._s(_vm.$t(button.title))),
                                      ]),
                                      _vm._v(" "),
                                      button.actionTitle && !_vm.flagTOOLBOX
                                        ? _c(
                                            "b-button",
                                            {
                                              staticClass: "btn",
                                              attrs: { size: "lg" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(button.actionTitle)
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }